// Coupon validation and discount calculation helpers
import { apiValidateCoupon } from '../api';

/**
 * Validate and apply a coupon code via backend API
 * @param {string} code - Coupon code entered by user
 * @param {number} cartTotal - Current cart total
 * @returns {Promise<{ success: boolean, coupon?: object, error?: string }>}
 */
export const validateCoupon = async (code, cartTotal, currencyCode = 'INR') => {
  const normalizedCode = code.trim().toUpperCase();
  if (!normalizedCode) {
    return { success: false, error: 'Please enter a coupon code.' };
  }
  try {
    const data = await apiValidateCoupon(normalizedCode, cartTotal, currencyCode);
    return { success: true, coupon: data.coupon };
  } catch (error) {
    return { success: false, error: error.message || 'Invalid coupon code.' };
  }
};

/**
 * Calculate discount amount based on applied coupon
 * @param {object|null} couponApplied - Applied coupon object
 * @param {number} cartTotal - Current cart total
 * @returns {number} Discount amount
 */
export const calculateDiscount = (couponApplied, cartTotal) => {
  if (!couponApplied) return 0;
  if (couponApplied.discount) return couponApplied.discount;
  return couponApplied.type === 'percent'
    ? Math.round((cartTotal * couponApplied.value) / 100)
    : couponApplied.value;
};

/**
 * Generate a unique order ID
 * @returns {string} Order ID string
 */
export const generateOrderId = () => {
  return `ORD-${Date.now().toString().slice(-10)}`;
};
